module.exports = __webpack_public_path__ + "static/media/link-new-product.7abef2e2.gif";